
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants",
      function () {
        return require("private-next-pages/restaurants.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants"])
      });
    }
  